'use strict';

/* jshint -W098 */
angular.module('mean.projects').controller('ProjectHoursController', ['$scope', 'Global', 'Projects', 'MeanUser', 'Users', '$filter', 'ProjectHours', 
  function($scope, Global, Projects, MeanUser, Users, $filter, ProjectHours) {
    $scope.global = Global;
    $scope.package = {
      name: 'projectAdmin'
    };

    $scope.user = MeanUser.user;
    $scope.projects = [];
    $scope.my_roles = [];
    $scope.tradesmen = [];
    $scope.hours = [];

    $scope.my_roles = MeanUser.user.roles;

    $scope.init = function() {
        Users.query({}, function(users) {
            $scope.tradesmen = users;
        });

        $scope.my_roles.forEach(function(role) {
            if(role === 'admin') {
                $scope.is_admin = true;
            } else if(role === 'mtc') {
                $scope.is_contractor = true;
            } else if(role === 'division') {
                $scope.is_division = true;
            } else if (role === 'tm') {
                $scope.is_manager = true;
            }
        });
        
        if($scope.is_admin) {
            //I want to see all the projects
            Projects.query({}, function(projects) {
                if(projects.length === 0) return;

                $scope.projects = projects;
            });
        } else if($scope.is_contractor) {
            //I want to see all of my contracted projects
            Projects.query({'mtc.name': MeanUser.user.name}, function(projects) {
                if(projects.length === 0) return;

                $scope.projects = projects;
            });
        } else if($scope.is_division) {
            //I want to see all of my contracted projects
            Projects.query({'mtc.division_manager_name': MeanUser.user.name}, function(projects) {
                if(projects.length === 0) return;

                $scope.projects = projects;
            });
        }
    };

    $scope.changeProject = function(){
    	console.log('project selected');
    };

    $scope.changeTradesman = function() {
    	ProjectHours.query({'project_id': $scope.selectedItem._id, 'username': $scope.selectedTradesman.username}, function(hours) {
    		$scope.hours = hours;
    	});
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/controllers/projectHour.js